import axios from 'axios';
import humps from 'humps';
import * as statusActions from '../redux/actions/statusActions';

axios.interceptors.request.use((request) => {
  const authToken = sessionStorage.jwt;
  if (authToken) {
    if (request.headers && !request.headers.Authorization) {
      request.headers.Authorization = `Bearer ${authToken}`;
    }
  }
  request.headers.post['Content-Type'] = 'application/json';
  if (request.data) {
    request.data = humps.decamelizeKeys(request.data);
  }
  return request;
});

axios.interceptors.response.use((response) => {
  if (response.data) {
    if (response.headers['content-type'] === 'application/pdf') {
      return response.data;
    }
    return humps.camelizeKeys(response.data);
  }
});

// This handler must be called later since it relies on the store, and
// importing store to this file is a circular dependency

export function interceptExpiredToken(store) {
  axios.interceptors.response.use(undefined, (err) => {
    if (err.response && err.response.data.token && err.response.data.token[0] === 'Expired token') {
      // Send action to prompt user to log back in
      store.dispatch(statusActions.tokenHasExpired());
    }
    return Promise.reject(err);
  });
}

export default axios;



// WEBPACK FOOTER //
// ./src/api/axios.js